// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.temporary-widget-class__container {
  position: fixed;
  z-index: 9999999;
}

.temporary-widget-class__container .temporary-widget-class__button {
  cursor: pointer;
  user-select: none;

  position: fixed;
  z-index: 999996;
  right: 33px;
  bottom: 33px;

  width: 56px;
  height: 56px;
  padding: 0;

  filter: drop-shadow(0 1px 6px rgb(0 0 0 / 6%)) drop-shadow(0 2px 32px rgb(0 0 0 / 16%));
  border: 0;
  border-radius: 50px;

  transition: all 0.2s ease-out;
}

.temporary-widget-class__container .temporary-widget-class__button:hover {
  transform: scale(1.115);
}

.temporary-widget-class__container .temporary-widget-class__button:focus {
  outline: 0;
}

.temporary-widget-class__container .temporary-widget-class__iframe-wrapper {
  pointer-events: all;

  position: fixed;
  right: 33px;
  bottom: 110px;

  overflow: hidden;

  width: 360px;
  max-width: calc(100vw - 10px);
  height: 600px;
  min-height: 260px;
  max-height: calc(100vh - 110px);

  background-color: white;
  border-radius: 20px;
  box-shadow: 0 1px 6px rgb(0 0 0 / 6%), 0 2px 32px rgb(0 0 0 / 16%);

  transition: width 200ms ease 0s, height 200ms ease 0s, max-height 200ms ease 0s,
    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s, opacity 83ms ease-out 0s;
}

.iframe-wrapper-hidden {
  transform: scale(0);
  opacity: 0;
}

.iframe-wrapper-shown {
  opacity: 1;
}

.left-open {
  transform-origin: left bottom;
}

.right-open {
  transform-origin: right bottom;
}

.temporary-widget-class__iframe-wrapper iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  border: none;
}

.temporary-widget-class__container .temporary-widget-class__notificator {
  position: fixed;
  z-index: 999997;
  right: 50px;
  bottom: 60px;

  display: none;

  width: 20px;
  height: 20px;

  font-family: Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  line-height: 20px;
  color: var(--notificator-color);
  text-align: center;

  background-color: #fff;
  border: none;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgb(0 0 0 / 6%), 0 2px 32px rgb(0 0 0 / 16%);
}

.temporary-widget-class__container .temporary-widget-class__notificator.visible {
  right: 25px;
  bottom: 70px;

  display: block;

  animation-name: bounceInUp;
  animation-duration: 1.2s;
  animation-fill-mode: both;
}

.temporary-widget-class__container.is-iframe-shown .temporary-widget-class__notificator {
  display: none;
}

.temporary-widget-class__container.has-left-alignment .temporary-widget-class__iframe-wrapper,
.temporary-widget-class__container.has-left-alignment .temporary-widget-class__button,
.temporary-widget-class__container.has-left-alignment .temporary-widget-class__notificator {
  right: auto;
}

.temporary-widget-class__container.has-left-alignment .temporary-widget-class__iframe-wrapper {
  left: 33px;
}

.temporary-widget-class__container.has-left-alignment .temporary-widget-class__button {
  left: 33px;
}

.temporary-widget-class__container.has-left-alignment .temporary-widget-class__notificator {
  left: 23px;
}

@media (width <= 395px) {
  .temporary-widget-class__container .temporary-widget-class__iframe-wrapper {
    right: 5px;
  }

  .temporary-widget-class__container.has-left-alignment .temporary-widget-class__iframe-wrapper {
    left: 5px;
  }
}

@media (height <= 700px) {
  .temporary-widget-class__container .temporary-widget-class__iframe-wrapper {
    bottom: 70px;
    max-height: calc(100vh - 70px);
  }

  .temporary-widget-class__container .temporary-widget-class__button {
    right: 5px;
    bottom: 5px;
  }

  .temporary-widget-class__container.has-left-alignment .temporary-widget-class__button {
    left: 5px;
  }

  .temporary-widget-class__container .temporary-widget-class__notificator {
    right: 3px !important;
    bottom: 43px !important;
  }

  .temporary-widget-class__container.has-left-alignment .temporary-widget-class__notificator {
    left: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/widget/widget.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;;EAEZ,WAAW;EACX,YAAY;EACZ,UAAU;;EAEV,uFAAuF;EACvF,SAAS;EACT,mBAAmB;;EAEnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;;EAEnB,eAAe;EACf,WAAW;EACX,aAAa;;EAEb,gBAAgB;;EAEhB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,+BAA+B;;EAE/B,uBAAuB;EACvB,mBAAmB;EACnB,kEAAkE;;EAElE;2EACyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;;EAEZ,aAAa;;EAEb,WAAW;EACX,YAAY;;EAEZ,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;;EAElB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".temporary-widget-class__container {\n  position: fixed;\n  z-index: 9999999;\n}\n\n.temporary-widget-class__container .temporary-widget-class__button {\n  cursor: pointer;\n  user-select: none;\n\n  position: fixed;\n  z-index: 999996;\n  right: 33px;\n  bottom: 33px;\n\n  width: 56px;\n  height: 56px;\n  padding: 0;\n\n  filter: drop-shadow(0 1px 6px rgb(0 0 0 / 6%)) drop-shadow(0 2px 32px rgb(0 0 0 / 16%));\n  border: 0;\n  border-radius: 50px;\n\n  transition: all 0.2s ease-out;\n}\n\n.temporary-widget-class__container .temporary-widget-class__button:hover {\n  transform: scale(1.115);\n}\n\n.temporary-widget-class__container .temporary-widget-class__button:focus {\n  outline: 0;\n}\n\n.temporary-widget-class__container .temporary-widget-class__iframe-wrapper {\n  pointer-events: all;\n\n  position: fixed;\n  right: 33px;\n  bottom: 110px;\n\n  overflow: hidden;\n\n  width: 360px;\n  max-width: calc(100vw - 10px);\n  height: 600px;\n  min-height: 260px;\n  max-height: calc(100vh - 110px);\n\n  background-color: white;\n  border-radius: 20px;\n  box-shadow: 0 1px 6px rgb(0 0 0 / 6%), 0 2px 32px rgb(0 0 0 / 16%);\n\n  transition: width 200ms ease 0s, height 200ms ease 0s, max-height 200ms ease 0s,\n    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s, opacity 83ms ease-out 0s;\n}\n\n.iframe-wrapper-hidden {\n  transform: scale(0);\n  opacity: 0;\n}\n\n.iframe-wrapper-shown {\n  opacity: 1;\n}\n\n.left-open {\n  transform-origin: left bottom;\n}\n\n.right-open {\n  transform-origin: right bottom;\n}\n\n.temporary-widget-class__iframe-wrapper iframe {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.temporary-widget-class__container .temporary-widget-class__notificator {\n  position: fixed;\n  z-index: 999997;\n  right: 50px;\n  bottom: 60px;\n\n  display: none;\n\n  width: 20px;\n  height: 20px;\n\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 20px;\n  color: var(--notificator-color);\n  text-align: center;\n\n  background-color: #fff;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 0 1px 6px rgb(0 0 0 / 6%), 0 2px 32px rgb(0 0 0 / 16%);\n}\n\n.temporary-widget-class__container .temporary-widget-class__notificator.visible {\n  right: 25px;\n  bottom: 70px;\n\n  display: block;\n\n  animation-name: bounceInUp;\n  animation-duration: 1.2s;\n  animation-fill-mode: both;\n}\n\n.temporary-widget-class__container.is-iframe-shown .temporary-widget-class__notificator {\n  display: none;\n}\n\n.temporary-widget-class__container.has-left-alignment .temporary-widget-class__iframe-wrapper,\n.temporary-widget-class__container.has-left-alignment .temporary-widget-class__button,\n.temporary-widget-class__container.has-left-alignment .temporary-widget-class__notificator {\n  right: auto;\n}\n\n.temporary-widget-class__container.has-left-alignment .temporary-widget-class__iframe-wrapper {\n  left: 33px;\n}\n\n.temporary-widget-class__container.has-left-alignment .temporary-widget-class__button {\n  left: 33px;\n}\n\n.temporary-widget-class__container.has-left-alignment .temporary-widget-class__notificator {\n  left: 23px;\n}\n\n@media (width <= 395px) {\n  .temporary-widget-class__container .temporary-widget-class__iframe-wrapper {\n    right: 5px;\n  }\n\n  .temporary-widget-class__container.has-left-alignment .temporary-widget-class__iframe-wrapper {\n    left: 5px;\n  }\n}\n\n@media (height <= 700px) {\n  .temporary-widget-class__container .temporary-widget-class__iframe-wrapper {\n    bottom: 70px;\n    max-height: calc(100vh - 70px);\n  }\n\n  .temporary-widget-class__container .temporary-widget-class__button {\n    right: 5px;\n    bottom: 5px;\n  }\n\n  .temporary-widget-class__container.has-left-alignment .temporary-widget-class__button {\n    left: 5px;\n  }\n\n  .temporary-widget-class__container .temporary-widget-class__notificator {\n    right: 3px !important;\n    bottom: 43px !important;\n  }\n\n  .temporary-widget-class__container.has-left-alignment .temporary-widget-class__notificator {\n    left: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
